<template>
  <div id="customTabs">
    <div class="container">
      <h1>Custom Tabs</h1>
      <form @submit.prevent>
        <div class="form-group">
          <div
            class="mb-3 card p-2"
            v-for="(tab, index) in tabs"
            v-bind:key="index"
          >
            <div class="form-group">
              <label><strong>Tab {{ index + 1 }} Title</strong></label>
              <input class="form-control" v-model="tab.title" />
            </div><!-- /.form-group -->
            <div class="form-group">
              <label><strong>Tab {{ index + 1 }} Icon</strong></label>
              <b-form-select v-model="tab.iconClass" :options="tabIconClasses"></b-form-select>
            </div><!-- /.form-group -->
            <div class="form-group">
              <label><strong>Tab {{ index + 1 }} Content</strong></label>
              <p>
                <span
                  @click="switchContentMode('richText', index)"
                  class="badge badge-secondary mr-1 clickable"
                  :class="{ active: tab.mode === 'richText' }"
                >Rich Text</span>
                <span
                  @click="switchContentMode('html', index)"
                  class="badge badge-secondary mr-1 clickable"
                  :class="{ active: tab.mode === 'html' }"
                >HTML</span>
                <span
                  @click="switchContentMode('embed', index)"
                  class="badge badge-secondary mr-1 clickable"
                  :class="{ active: tab.mode === 'embed' }"
                >Embed URL</span>
                <span
                  @click="switchContentMode('link', index)"
                  class="badge badge-secondary mr-1 clickable"
                  :class="{ active: tab.mode === 'link' }"
                >Link URL</span>
              </p>
              <quill-editor
                v-if="tab.mode === 'richText'"
                v-model="tab.content"
                :options="editorOptions"
              ></quill-editor>
              <textarea
                v-if="tab.mode === 'html'"
                class="form-control"
                v-model="tab.content"
              />
              <input
                v-if="tab.mode === 'embed' || tab.mode === 'link'"
                class="form-control"
                v-model="tab.content"
              />
            </div><!-- /.form-group -->
            <b-btn
              class="btn-danger"
              @click="removeTab(index)"
            >
              <i class="fas fa-minus"></i> Remove Tab
            </b-btn>
          </div><!-- /.row -->
        </div><!-- /.form-group -->
        <b-btn
          @click="addTab()"
        ><i class="fas fa-plus"></i> Add Custom Tab</b-btn>
      </form>
      <button
        class="btn btn-success mb-4 mt-4"
        @click="saveSettings()"
      >
        Save Custom Tabs
      </button>
    </div><!-- /.container -->
  </div><!-- /#trailHub -->
</template>

<script>
import { mapState } from 'vuex'
const fb = require('../../../firebaseConfig.js')
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'

export default {
  data() {
    return {
      tabs: [],
      tabIconClasses: [
        { value: 'fas fa-info-circle', text: 'Information' },
        { value: 'fas fa-calendar-check', text: 'Calendar' },
        { value: 'fas fa-shopping-cart', text: 'Shopping Cart' },
        { value: 'fas fa-shopping-bag', text: 'Shopping Bag' },
        { value: 'fas fa-skiing-nordic', text: 'Nordic Skiing' }
      ],
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'header': [1, 2, 3, false] }],
            [{ 'align': [] }],
            ['clean'],
            ['link', 'video']
          ]
        }
      }
    }
  },
  components: {
    quillEditor
  },
  computed: {
    ...mapState([
      'dashboard'
    ])
  },
  created() {
    if (this.dashboard.data.modules.customTabs.tabs) {
      this.tabs = this.dashboard.data.modules.customTabs.tabs
    }
  },
  methods: {
    switchContentMode (mode, index) {
      if (mode === 'embed') {
        this.tabs[index].content = ''
      }
      this.tabs[index].mode = mode
    },
    saveSettings() {
      this.dashboard.data.modules.customTabs.tabs = this.tabs
      fb.dashboardsCollection.doc(this.dashboard.data.id).update({
        modules: this.dashboard.data.modules
      }).then(e => {
        const revData = this.dashboard.data
        revData.updatedOn = new Date()
        fb.dashboardRevisionsCollection.add(revData)
        alert('Successfully updated settings!')
        this.$store.commit('fetchDashboard', {id: this.$route.params.id, customStyles: false})
      }).catch(err => {
        console.log(err.message)
      })
    },
    removeTab(index) {
      this.tabs.splice(index, 1)
    },
    addTab() {
      this.tabs.push({
        title: '',
        iconClass: 'fas fa-info-circle',
        content: '',
        mode: 'richText'
      })
    }
  }
}
</script>

<style scoped>
.badge.active {
  background-color: #007bff;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/modules/CustomTabs.vue